export const LANGUAGE_COUNTRY_DICT = {
  en: 'gb',
  de: 'de',
  fr: 'fr',
  es: 'es',
  it: 'it',
};

export const CUSTOM_MASKS = {
  de: '... ................',
};
